import { headerAwareSmoothScroll as kitHeaderAwareSmoothScroll } from '@carnica/landing-kit/utils';

/**
 * @deprecated Утилиты устарели. Используйте аналогичные функции из пакета @carnica/landing-kit/utils
 */
export const headerAwareSmoothScroll = kitHeaderAwareSmoothScroll;
